/*
 * File: SecurityPromise.styles.js
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on February 8, 2022 at 3:21 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: April 29, 2024 at 10:34 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div`
    max-width: 700px;
    overflow-wrap: break-word;
    box-sizing: border-box;
	margin: 0 auto;
`;
